var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profit"},[_c('Header',{attrs:{"bg":"red","titles":"开票流程"}}),_vm._l((_vm.imgs),function(item){return _c('img',{key:item +'s',staticClass:"pros",attrs:{"src":item,"alt":""}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }